import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { AppRole } from "@/types/role";
import { getEffectiveRole } from "@/lib/roles";

export const useUserRole = () => {
  const [role, setRole] = useState<AppRole | null>(null);
  const [isOwner, setIsOwner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        // Fetch ALL roles for the user (no .single() — users can have multiple roles)
        const { data: userRoles } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id);

        // Fetch owner status
        const { data: profile } = await supabase
          .from("profiles")
          .select("is_owner")
          .eq("id", user.id)
          .single();

        if (profile) {
          setIsOwner(profile.is_owner || false);
          
          // If user is owner, always treat them as having owner role
          if (profile.is_owner) {
            setRole('owner');
          } else {
            setRole(getEffectiveRole(userRoles || []));
          }
        } else {
          setRole(getEffectiveRole(userRoles || []));
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  return { role, isOwner, loading };
};
